import { useEffect, useState } from "react";
import { ShieldAlert, Loader2 } from "lucide-react";
import { api } from "../lib/api";
import { WaSendButton, portalLink } from "./WaSendButton";

export const DisciplinarySection = ({ employeeId }) => {
  const [d, setD] = useState(null);
  useEffect(() => { api.employeeDisciplinary(employeeId).then(setD).catch(() => setD({ decisions: [], cases: [] })); }, [employeeId]);
  if (!d) return <Loader2 className="mx-auto mt-4 h-5 w-5 animate-spin text-slate-300" />;
  const empty = !d.decisions.length && !d.cases.length;
  return (
    <div className="mt-4 rounded-2xl border border-red-100 bg-red-50/30 p-3" data-testid="disciplinary-section">
      <p className="mb-2 flex flex-wrap items-center gap-2 font-heading font-bold text-red-800"><ShieldAlert className="h-4 w-4" /> السجل التأديبي
        <span className="rounded-full bg-white px-2 text-xs font-semibold text-slate-600" data-testid="disc-counts">إنذارات {d.warnings || 0} · خصومات {d.deductions || 0} · قضايا {d.cases.length} · مخالفات مرورية {d.violations_count || 0}</span></p>
      {empty ? <p className="text-xs text-slate-400">سجل نظيف — لا توجد إنذارات أو إجراءات</p> : (
        <div className="space-y-1">
          {d.decisions.map((x) => (
            <div key={x.id} className="flex items-center gap-2 rounded-lg bg-white px-2 py-1 text-xs" data-testid={`disc-dec-${x.id}`}>
              <span className="rounded bg-red-100 px-1.5 font-bold text-red-700">{x.type}</span><span className="flex-1 truncate">{x.title}</span>
              <span className="font-mono text-slate-400">{x.number} · {x.date}</span><span className="text-slate-400">{x.status === "signed" ? "موقّع ✓" : x.status === "sent" ? "بانتظار التوقيع" : "مسودة"}</span>
              <WaSendButton employeeId={employeeId} refType="decision" refId={x.id} testid={`disc-wa-${x.id}`} emailTitle={x.title || x.type} className="!h-6 !w-6"
                text={`السلام عليكم\nصدر بحقك ${x.type}: ${x.title} (رقم ${x.number}) بتاريخ ${x.date}.${x.status === "signed" ? "" : `\nيرجى الاطلاع عليه وتوقيعه من بوابة الموظف:\n${portalLink("decisions")}`}`} />
            </div>))}
          {d.cases.map((x) => (
            <div key={x.id} className="flex items-center gap-2 rounded-lg bg-white px-2 py-1 text-xs" data-testid={`disc-case-${x.id}`}>
              <span className="rounded bg-[#0f1f3d] px-1.5 font-bold text-amber-200">قانوني</span><span className="flex-1 truncate">{x.title} · {x.category}</span>
              <span className="font-mono text-slate-400" dir="ltr">{x.number}</span><span className="text-slate-500">{x.result || (x.status === "closed" ? "مقفلة" : "جارية")}</span>
            </div>))}
        </div>
      )}
    </div>
  );
};
